export default function SFMyOutlinedIcon({}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="10.5" r="7.5" stroke="#8B8B8B" strokeWidth="2" />
      <path
        d="M4 22C5.61788 19.588 8.3731 18 11.5 18C14.6269 18 17.3821 19.588 19 22"
        stroke="#8B8B8B"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 9V11"
        stroke="#8B8B8B"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 9V11"
        stroke="#8B8B8B"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
